import type { AllRouteEndpoints } from "../routeTypes";
export const appsMultiLanguageSettingsRemoveTranslationsCacheKeys: AllRouteEndpoints[] = [];
